<template>
    <section class="mb-20 lg:mb-0 p-5 sm:p-10 lg:p-20 bg-gradient-to-b from-gray-100 to-gray-200 rounded-lg shadow-inner">
        <div class="max-w-6xl mx-auto">
            <!-- Header Block -->
            <div class="text-center mb-16">
                <h2 class="text-2xl lg:text-3xl font-extrabold text-slate-900 leading-snug mb-6">{{ title }}</h2>
                <div class="text-slate-600 max-w-4xl mx-auto text-sm lg:text-base" v-html="description"></div>
            </div>

            <!-- Features Block -->
            <div>
                <h3 class="mt-12 mb-10 text-xl font-bold text-center text-slate-800">{{ featuresTitle }}</h3>

                <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
                    <FeatureCard v-for="(card, idx) in featureCards" :key="idx" :title="card.title" :text="card.text" :icon-class="card.iconClass" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import FeatureCard from './FeatureCard.vue';

export default {
    name: 'HowItWorksSection',
    components: {
        FeatureCard
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        featuresTitle: {
            type: String,
            default: 'Das erhalten Sie konkret:'
        },
        featureCards: {
            type: Array,
            required: true
        }
    }
};
</script>
